import "./page-sar-antenna.less";
import "scriptsPath/general";
import "scriptsPath/slick-slider-sar-antenna";
import Modal from "bootstrap/js/dist/modal";
import "../../components/modals.scss";

let modalDownload;

document.addEventListener("DOMContentLoaded", function () {
	const modalDownloadElement = document.getElementById("modalDownload");

	if (modalDownloadElement) {
		modalDownload = new Modal(modalDownloadElement);
	}

	$(".js-hide-modal").on("click", function () {
		modalDownload.hide();
	});
});

(function formSent() {
	let $wpcf7Elem = document.querySelectorAll(".wpcf7");

	$wpcf7Elem.forEach(function (formItem) {
		formItem.addEventListener("wpcf7mailsent", (e) => {
			modalDownload.show();
		});

		// formItem.addEventListener("wpcf7invalid", function (event) {}, false);

		// formItem.addEventListener("wpcf7mailfailed", function (event) {}, false);

		// formItem.addEventListener("wpcf7spam", function (event) {}, false);
	});
})();